<a *ngIf="isVisible | async" class="d-flex flex-row"
   [tabIndex]="-1"
   [routerLink]="[searchLink]"
   [queryParams]="addQueryParams" queryParamsHandling="merge">
  <label class="mb-0">
    <input type="checkbox" [checked]="false" class="my-1 align-self-stretch"/>
    <!-- Atmire Modifications START -->
    <ng-container *ngIf="filterConfig.name === 'language'; else other">
      <span class="filter-value px-1">
        {{ 'language.' + filterValue.value + '.label' | translate}}
      </span>
    </ng-container>
    <ng-template #other>
      <span class="filter-value px-1">
        {{ 'search.filters.' + filterConfig.name + '.' + filterValue.value | translate: {default: filterValue.value} }}
      </span>
    </ng-template>
    <!-- Atmire Modifications END -->
  </label>
  <span class="float-right filter-value-count ml-auto">
                        <span class="badge badge-secondary badge-pill">{{filterValue.count}}</span>
                    </span>
</a>
